export default function SkillItem({ skill }) {
  return (
    <div className="bg-gray-800/50 p-2.5 rounded-lg border border-emerald-400/20 text-center
      hover:bg-emerald-400/30 hover:border-emerald-300 hover:scale-110
      transform transition-all duration-300 ease-out
      hover:shadow-2xl hover:shadow-emerald-400/50 hover:brightness-125
      relative overflow-hidden group">
      
      {/* Glowing overlay effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-emerald-400/0 via-emerald-400/20 to-emerald-400/0
        translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-out"></div>
      
      <span className="text-gray-300 font-medium text-sm group-hover:text-white group-hover:font-semibold
        transition-all duration-300 relative z-10 group-hover:drop-shadow-lg">
        {skill}
      </span>
    </div>
  );
}